import { render, staticRenderFns } from "./reports.page.vue?vue&type=template&id=4361e1de&scoped=true&"
import script from "./reports.page.vue?vue&type=script&lang=js&"
export * from "./reports.page.vue?vue&type=script&lang=js&"
import style0 from "./reports.page.vue?vue&type=style&index=0&id=4361e1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4361e1de",
  null
  
)

export default component.exports